module.exports = __webpack_public_path__ + "/login_ui/img/sv-3186524c660ffbf0f8419007d07c9ea2.svg";